import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=6dfd16f5&"
import script from "./BlogItem.vue?vue&type=script&lang=ts&"
export * from "./BlogItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports